const oldItems = [
  "Reports that show data but don't tell you what to do",
  "Requires a data analyst or tech-savvy manager",
  "Complex dashboards built for the IT team, not the store owner",
  "Looks impressive, but changes nothing in your buying decisions",
  "Takes days to set up and maintain",
];

const newItems = [
  "Every insight comes with a clear action — clear, stop buying, or hold",
  "Designed for store owners and retail managers, not analysts",
  "Simple enough for anyone on your team to read and act on",
  "Directly improves your next purchase order",
  "Upload once and get results in minutes",
];

export default function WhyDifferent() {
  return (
    <div className="sm-section-full">
      <div className="sm-section">
        <div className="sm-reveal" style={{ maxWidth: 540 }}>
          <span className="sm-eyebrow">Why It's Different</span>
          <h2 className="sm-h2">
            Not another dashboard.
            <br />
            An action list.
          </h2>
          <p className="sm-h2-sub">
            Most tools show you reports. Stock Move shows you what to do next.
          </p>
        </div>

        <div className="sm-diff-grid sm-reveal sm-reveal-d2">
          <div className="sm-diff-card old">
            <span className="sm-diff-badge old">Traditional Reporting</span>
            <h3 className="sm-diff-h3">Lots of data, no direction</h3>
            <ul className="sm-diff-list">
              {oldItems.map((item, index) => (
                <li key={index} className="sm-diff-item">
                  <span className="sm-diff-dot" />
                  {item}
                </li>
              ))}
            </ul>
          </div>

          <div className="sm-diff-card new">
            <span className="sm-diff-badge new">Stock Move</span>
            <h3 className="sm-diff-h3">Clear actions, immediate impact</h3>
            <ul className="sm-diff-list">
              {newItems.map((item, index) => (
                <li key={index} className="sm-diff-item">
                  <span className="sm-diff-dot" />
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}